// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2cceb7e8","519":"91dfb526","699":"c5e58e7e","719":"31a5a374","869":"23a5f185"}[chunkId] + ".chunk.js";
};